import React from "react";
import { useRouteMatch } from "react-router-dom";

import FormProductionSell from "../../new/form";

const FormProductionSellEdit = ({ onCancel }) => {
  const {
    params: { id: farmSellId },
  } = useRouteMatch();

  return (
    <FormProductionSell onCancel={onCancel} farmSellId={farmSellId} />
  );
};

export default FormProductionSellEdit;
